import { Component, Input } from '@angular/core';
import { IDropdownLinks } from '@common/interfaces/header-menu.interface';
import { NavigationService } from '@services/navigation/navigation.service';

@Component({
  selector: 'app-dropdown-button',
  templateUrl: './dropdown-button.component.html',
  styleUrls: ['./dropdown-button.component.scss'],
})
export class DropdownButtonComponent  {

  @Input() buttonLabel: string;
  @Input() icon: string;
  @Input() route: string;
  @Input() dropdownLinks: IDropdownLinks[];
  @Input() isCurrentRoute: boolean;

  constructor(
    private navService: NavigationService,
  ) {
    this.dropdownLinks = [];
  }

  public clickEvent(url?: string) {
    const route = url ?? this.route;
    this.navService.goTo(route);
  }

  get buttonClass() {
    const classToReturn = 'btn btn-menu-header responsive';
    return this.isCurrentRoute ? `${classToReturn} hover` : classToReturn;
  }
}
